const GET_STATUS_SAT_DESCARGA_MASIVA = 'GET_STATUS_SAT_DESCARGA_MASIVA';

const getStatusSATDescargaMasiva= data => {
    return {
        type: GET_STATUS_SAT_DESCARGA_MASIVA,
        data
    };
}


export default {
    types: {
        GET_STATUS_SAT_DESCARGA_MASIVA,
    },    
    actions: {
        getStatusSATDescargaMasiva,
    }
}